import { BookingInfoSkeleton, HotelDetailsSkeleton, PoliciesSkeleton, SkeletonBlock } from "./HotelTransactionDetailsSkeleton.shared";

export default function HotelTransactionDetailsSkeletonMob() {
  return (
    <div className="flex w-full flex-col gap-6 pb-36">
      <BookingInfoSkeleton />
      <HotelDetailsSkeleton />
      <PoliciesSkeleton />
      <div className="shadow-bottom-sheet bg-background-default fixed start-0 end-0 bottom-0 z-50 rounded-t-xl p-4">
        <SkeletonBlock className="h-10 w-full" />
      </div>
    </div>
  );
}
